package com.partejar.app.feature.agenda.data

import kotlinx.datetime.LocalDateTime
import kotlin.js.Date

internal actual fun currentAgendaDateTime(): LocalDateTime {
    val now = Date()
    return LocalDateTime(
        year = now.getFullYear(),
        monthNumber = now.getMonth() + 1,
        dayOfMonth = now.getDate(),
        hour = now.getHours(),
        minute = now.getMinutes(),
        second = now.getSeconds(),
        nanosecond = now.getMilliseconds() * 1_000_000
    )
}

internal actual fun agendaEpochMillis(dateTime: LocalDateTime): Long = Date(
    dateTime.year,
    dateTime.monthNumber - 1,
    dateTime.dayOfMonth,
    dateTime.hour,
    dateTime.minute,
    dateTime.second,
    dateTime.nanosecond / 1_000_000
).getTime().toLong()
